<template>
  <div class="hc-detail-item hc-detail-item--edit" :class="{ 'hc-detail-item--wide': wide }">
    <span class="hc-detail-item__label">
      {{ label }}<span v-if="required" class="hc-detail-item__req" aria-hidden="true">*</span>
    </span>
    <div class="hc-detail-item__field">
      <slot />
    </div>
    <p v-if="error" class="hc-detail-item__error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'ProfileEditItem',
  props: {
    label: { type: String, required: true },
    required: { type: Boolean, default: false },
    wide: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
};
</script>
